import { customScrollMinimal, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const ScrollableContainer = styled.div`
  max-height: min(60vh, 480px);
  overflow-y: auto;
  ${customScrollMinimal}
`;

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 200px;
  margin-bottom: 12px;
  cursor: pointer;
  &:hover {
    background-color: var(--surface-hover);
  }
  padding: 0;
`;

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleLabel = styled.div`
  ${typographyV2.titleSm};
`;

export const CategoryLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;
